export const QUERIES = {
  GET_PICKUP_TIMES: 'GET_PICKUP_TIMES',
}
